import {getField, setField} from 'src/schemas/utils';

export default {
  props: {
    spec: {type: Object, required: true},
    model: {},
    $parentForm: {},
    rootModel: {},
    $rootForm: {},
    readonly: {},
    name: {type: String},
  },
  computed: {
    value: {
      get() {
        return getField.call(this, this.model, this.spec);
      },
      set(v) {
        return setField.call(this, this.model, this.spec, v);
      },
    },
    _name() {
      return this.name || this.spec.prop;
    },
    _readonly() {
      return (typeof this.readonly === 'function' ? this.readonly.call(this) : this.readonly)
        || (typeof this.spec.readonly === 'function' ? this.spec.readonly.call(this) : this.spec.readonly);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Forms/Fields/mixin.js